import { Component, OnInit, Input } from "@angular/core";
import { WinService } from "src/app/services/win.service";
import { BsModalService, BsModalRef, ModalOptions } from "ngx-bootstrap/modal";
import { ReviewformComponent } from "src/app/components/modals/reviewform/reviewform.component";
import { SessionService } from "src/app/services/session.service";
import { CustomerService } from "src/app/services/api/customer.service";
import { ActivatedRoute } from "@angular/router";
import { Router } from "@angular/router";
import { OwlOptions } from "ngx-owl-carousel-o";
import { ProductService } from "src/app/services/api/product.service";

@Component({
	selector: "app-reviews",
	templateUrl: "./reviews.component.html",
	styleUrls: ["./reviews.component.scss"],
})
export class ReviewsComponent implements OnInit {
	customOptions: OwlOptions = {
		loop: true,
		nav: true,
		dots: false,
		navSpeed: 1000,
		items: 1,
		autoplay: false,
		autoplayTimeout: 5000,
		autoplayHoverPause: true,
		responsive: {
			0: { items: 1 },
			400: { items: 1 },
			740: { items: 1 },
			940: { items: 1 },
		},
	};

	@Input() product: any = null;

	modalRef: BsModalRef;
	reviews: any = null;
	loadMoreBtn: boolean = true;
	isOrder: any = false;
	reviewRequestModal: any = false;
	doubleForm: boolean = false;
	reviewsShow: boolean = true;
	arrayOfReviews: any;
	tempArrRev: any=[];
	newArrRev: any=[];

	constructor(
		public winService: WinService,
		public modalService: BsModalService,
		public sessionService: SessionService,
		public _route: ActivatedRoute,
		public router: Router,
		public customerService: CustomerService,
		public productService: ProductService
	) {}

	ngOnInit() {
		this._route.paramMap.subscribe((url_param) => {
		this.reviews = null;
			this.getReviews();
		});
	}

	getReviews() {
		if (this.product) {
			if (this.sessionService.user.isLogedIn) {
				this.customerService.getLogedInCustomer().then((c) => {
					this.loadMore();
				});

				this.customerService
				.makeRequest(
					"/rest/entrelable/V1/lns-api/isordered/durable-sticker",
					"",
					"GET"
				)
				.then((isOrder) => {
					// Get customer ID to check for previous reviews
					// This is to avoid spamming of review form modal pop-up
					// Review request modal pop-up

					this.isOrder = isOrder;

					this._route.queryParams.subscribe((params) => {
						let products = params['products'];
						if(typeof products != 'undefined'){
							products = products.split('_');
							this.openReviewFormMulti(products);
						}

						// Get URL params
						// let matte: string = params["matte_review"];
						// let durable: string = params["durable_review"];
						// let matte_durable: string = params["durable_matte_review"];

						// Check which product to review
						// if (this.isOrder) {
						// 	// Check which URL has params value
						// 	if (matte != null) {
						// 		this.product.sku = "matte-sticker";
						// 		this.product.id = 21;
						// 		this.openReviewForm();
						// 	} else if (durable != null) {
						// 		this.product.sku = "durable-sticker";
						// 		this.product.id = 12;
						// 		this.openReviewForm();
						// 	} else if (matte_durable != null) {
						// 		this.product.name = "Matte Sticker";
						// 		this.product.sku = "matte-sticker";
						// 		this.product.id = 21;
						// 		this.openReviewForm();
						// 		this.doubleForm = true;
						// 	}
						// }
					});
				});
			} else {
				this.loadMore();
			}
		} else {
			setTimeout((f) => {
				this.getReviews();
			}, 500);
		}
	}

	/**
	 * when the link came from review request email it is always for multiple product review
	 * so we need to assync open the review form 
	 * this method is new form 7/20/2021 
	 * 
	 * the function is not assync it self
	 * but how it works make it assyn
	 */
	openReviewFormMulti(products, index:number = 0){
		if(typeof products[index] != 'undefined'){
			let sku = products[index];
			this.productService.getProductBySku(sku).then(product => {
				if(product){
					this.product = product;
					index++;
					this.openReviewForm((myData) => {
						this.modalRef.hide();
						if (myData) {
						}
						this.openReviewFormMulti(products, index);
					});
				}
			});
		} else {
			this.router.navigate(["/" + this.product.sku + ".html"]);
		}
	}

	/**
	 * open the review form modal
	 * @param callback null || function new from 7/20/2021 
	 * if the callback is a function 
	 * the callback will be used instead
	 * 
	 * the callback param is new from 7/20/2021 
	 * we need to pass this param so that the form will not navigate 
	 * when it is closed because the openReviewFormMulti() method 
	 * is new as well from 7/20/2021
	 */
  	openReviewForm(callback:any = null) {
		let config: ModalOptions = {
			backdrop: "static",
			keyboard: false,
			animated: true,
			ignoreBackdropClick: true,
			initialState: {
				product: this.product,
			},
		};

		this.modalRef = this.modalService.show(ReviewformComponent, config);
		this.modalRef.setClass("login-modal modal-dialog-centered");
		this.modalRef.content.onClose = (myData) => {
			if(typeof callback == 'function'){
				callback(myData);
			} else {
				this.modalRef.hide();
				if (myData) {
					if (this.doubleForm) {
						this.product.sku = "durable-sticker";
						this.product.name = "Durable Sticker";
						this.product.id = 12;
						this.openReviewForm();
						this.doubleForm = false;
					} else {
						this.reviews = null;
						this.loadMore();
						this.router.navigate(["/" + this.product.sku + ".html"]);
					}
				}
			}
		};
  	}

  	loadMore() {
		let page = 1;
		let last_page = 1;
		if (this.reviews) {
			page = this.reviews.current_page + 1;
			last_page = this.reviews.last_page;
		}

    	this.loadMoreBtn = false;
		if (this.product && page <= last_page) {
		this.customerService
			.get(
			"/rest/entrelable/V1/lns-api/product/review/" +
				this.product.id +
				"/?page=" +
				page +
				"&pageSize=30"
			)
			.subscribe((reviews) => {
				let rev: any = reviews[0];
				if (!this.reviews && reviews) {
					this.reviews = rev;
				} else {
					this.reviews.current_page = rev.current_page;
					this.reviews.last_page = rev.last_page;
					rev.data.forEach((_rev) => {
					this.reviews.data.push(_rev);
					});
				}
				if (page == this.reviews.last_page) {
					this.loadMoreBtn = false;
				} else {
					this.loadMoreBtn = true;
				}
				this.reviews.data.forEach((value, i) => {
					if(i == 0){
						this.tempArrRev.push(value);
					}
					else{
						if (i % 3 != 0) {
							this.tempArrRev.push(value);
						} else {
							this.newArrRev.push(this.tempArrRev);
							this.tempArrRev = [];
							this.tempArrRev.push(value);
						}
					} 
				});
				if(this.tempArrRev.length > 0){
					this.newArrRev.push(this.tempArrRev);
				}
			});
		} else {
			setTimeout((f) => {
				this.loadMore();
			}, 500);
		}
  	}

	/**
	 * return the src of the image for sart ratings
	 * @param currentStart
	 */
	getStartIcon(currentStart, ratingStart) {
		let cs: any = parseInt(currentStart);
		let rs: any = parseInt(ratingStart);
		if (rs >= cs) {
			return "./assets/icons/star-solid.png";
		} else {
			return "./assets/icons/star-blank.png";
		}
	}
}
